import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from '../../../../features/auth/application/service';

@Component({
  selector: 'app-user',
  standalone: true,
  templateUrl: './user.component.html',
  imports: [CommonModule],
})
export class UserComponent {
  private authService = inject(AuthService);

  readonly user = this.authService.user;
  readonly userName = this.authService.userName;
  readonly userRole = this.authService.userRole;
  readonly userInitials = this.authService.userInitials;
}


